/*
  IW Nuevo: home hero video loader. Picks the video that matches the layout, loads it only if the user allows
  motion and data, and fades it in over the poster once it can play. The poster stays if anything fails.
*/
(function () {
  var root = document.querySelector('[data-iw-hero-video]');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduced || saveData) return;

  var desktop = window.matchMedia('(min-width: 750px)').matches;
  var video = root.querySelector(desktop ? '.iw-hv__video--desktop' : '.iw-hv__video--mobile');
  if (!video || !video.dataset.src) return;

  video.addEventListener(
    'canplay',
    function () {
      video.classList.add('is-playing');
    },
    { once: true }
  );
  video.src = video.dataset.src;
  var p = video.play();
  if (p && p.catch) p.catch(function () {});
})();
